import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["id", "icon", "label", "checked", "onChangeHandler", "testId", "disabled", "Icon", "wrapperStyles"],
    _excluded2 = ["options", "onChangeHandler", "value", "customChipGroupStyles", "testId", "chipStyle"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _styled from "styled-components";
import { useMemo, memo, forwardRef } from 'react';
import { CheckCircleIcon } from '@heroicons/react/24/solid';
import { CircleMinusIcon } from '@restworld/utils-common';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var ChipCheckBox = /*#__PURE__*/memo(function (props) {
  var id = props.id,
      icon = props.icon,
      label = props.label,
      checked = props.checked,
      onChangeHandler = props.onChangeHandler,
      testId = props.testId,
      disabled = props.disabled,
      Icon = props.Icon,
      wrapperStyles = props.wrapperStyles,
      rest = _objectWithoutProperties(props, _excluded);

  var iconEl = useMemo(function () {
    var iconClasses = 'h-4 w-4 min-h-[16px] min-w-[16px]';
    return Icon ? /*#__PURE__*/_jsx(Icon, {
      className: iconClasses,
      stroke: disabled ? "#666676" : checked ? "#482485" : "#1c1c33"
    }) : checked ? /*#__PURE__*/_jsx(CheckCircleIcon, {
      className: iconClasses,
      fill: disabled ? "#666676" : "#482485"
    }) : /*#__PURE__*/_jsx(CircleMinusIcon, {
      className: iconClasses,
      fill: disabled ? "#666676" : "#1c1c33"
    });
  }, [Icon, checked, disabled]);
  var inputEl = useMemo(function () {
    return /*#__PURE__*/_jsx(CheckboxInput, _objectSpread({
      id: id,
      type: "checkbox",
      checked: checked,
      onChange: function onChange(e) {
        e.stopPropagation();
        if (onChangeHandler) onChangeHandler(id);
      },
      disabled: disabled
    }, rest));
  }, [checked, disabled, id, onChangeHandler, rest]);
  return /*#__PURE__*/_jsxs(StyledChipCheckbox, {
    "data-cy": testId,
    checked: checked,
    disabled: disabled,
    wrapperStyles: wrapperStyles,
    children: [iconEl, inputEl, /*#__PURE__*/_jsx(StyledLabel, {
      checked: checked,
      disabled: disabled,
      children: label
    })]
  }, id);
});
export var ChipCheckboxGroup = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var options = _ref.options,
      onChangeHandler = _ref.onChangeHandler,
      value = _ref.value,
      customChipGroupStyles = _ref.customChipGroupStyles,
      testId = _ref.testId,
      chipStyle = _ref.chipStyle,
      rest = _objectWithoutProperties(_ref, _excluded2);

  return /*#__PURE__*/_jsx(ChipGroupStyled, {
    "data-cy": testId,
    $customStyles: customChipGroupStyles,
    ref: ref,
    children: options === null || options === void 0 ? void 0 : options.map(function (chip, index) {
      return /*#__PURE__*/_jsx(ChipCheckBox, _objectSpread(_objectSpread(_objectSpread({
        testId: "".concat(chip.key)
      }, rest), _objectSpread(_objectSpread({}, chip), {}, {
        onChangeHandler: onChangeHandler
      })), {}, {
        checked: Array.isArray(value) ? (value === null || value === void 0 ? void 0 : value.indexOf(chip.id)) > -1 : value === chip.id,
        disabled: chip.disabled,
        wrapperStyles: chipStyle
      }), index.toString());
    })
  });
});

var StyledChipCheckbox = /*#__PURE__*/_styled.label.attrs({
  className: 'group'
}).withConfig({
  displayName: "checkboxchip__StyledChipCheckbox",
  componentId: "sc-179cmhj-0"
})(["", " ", " ", " ", ""], {
  "marginRight": "0.5rem",
  "display": "inline-flex",
  "height": "3rem !important",
  "cursor": "pointer",
  "alignItems": "center",
  "gap": "0.5rem",
  "borderRadius": "0.5rem",
  "borderWidth": "1px",
  "--tw-border-opacity": "1",
  "borderColor": "rgb(133 133 145 / var(--tw-border-opacity))",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(250 250 250 / var(--tw-bg-opacity))",
  "paddingTop": "0.5rem",
  "paddingBottom": "0.5rem",
  "paddingLeft": "0.75rem",
  "paddingRight": "0.75rem",
  ":hover": {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(235 235 237 / var(--tw-bg-opacity))"
  },
  ":focus-visible": {
    "outlineWidth": "4px",
    "outlineColor": "#e88a99"
  }
}, function (_ref2) {
  var checked = _ref2.checked;
  return checked ? {
    "--tw-border-opacity": "1",
    "borderColor": "rgb(72 36 133 / var(--tw-border-opacity))",
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(240 235 248 / var(--tw-bg-opacity))",
    "--tw-text-opacity": "1",
    "color": "rgb(72 36 133 / var(--tw-text-opacity))",
    ":hover": {
      "--tw-bg-opacity": "1",
      "backgroundColor": "rgb(240 235 248 / var(--tw-bg-opacity))"
    }
  } : {};
}, function (_ref3) {
  var disabled = _ref3.disabled;
  return disabled ? {
    "cursor": "not-allowed",
    "--tw-border-opacity": "1",
    "borderColor": "rgb(222 222 225 / var(--tw-border-opacity))",
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(222 222 225 / var(--tw-bg-opacity))",
    ":hover": {
      "--tw-bg-opacity": "1",
      "backgroundColor": "rgb(222 222 225 / var(--tw-bg-opacity))"
    }
  } : {};
}, function (_ref4) {
  var wrapperStyles = _ref4.wrapperStyles;
  return wrapperStyles || {};
});

var ChipGroupStyled = /*#__PURE__*/_styled.div.withConfig({
  displayName: "checkboxchip__ChipGroupStyled",
  componentId: "sc-179cmhj-1"
})(function (_ref5) {
  var $customStyles = _ref5.$customStyles;
  return [{
    "display": "flex",
    "flexDirection": "row",
    "flexWrap": "wrap",
    "gap": "0.5rem"
  }, $customStyles];
});

var CheckboxInput = /*#__PURE__*/_styled.input.withConfig({
  displayName: "checkboxchip__CheckboxInput",
  componentId: "sc-179cmhj-2"
})({
  "display": "none"
});

var StyledLabel = /*#__PURE__*/_styled.h5.withConfig({
  displayName: "checkboxchip__StyledLabel",
  componentId: "sc-179cmhj-3"
})(["", " ", " ", ""], {
  "width": "100%",
  "overflow": "hidden",
  "textOverflow": "ellipsis",
  "whiteSpace": "nowrap",
  "fontSize": "1rem !important",
  "lineHeight": "1.5rem !important",
  "fontWeight": "500",
  "--tw-text-opacity": "1",
  "color": "rgb(28 28 51 / var(--tw-text-opacity))"
}, function (_ref6) {
  var checked = _ref6.checked;
  return checked ? {
    "--tw-text-opacity": "1",
    "color": "rgb(72 36 133 / var(--tw-text-opacity))"
  } : {};
}, function (_ref7) {
  var disabled = _ref7.disabled;
  return disabled ? {
    "--tw-text-opacity": "1",
    "color": "rgb(102 102 118 / var(--tw-text-opacity))"
  } : {};
});